import {useEffect, useRef} from 'react';
import {KeyboardKeyType} from '../../common/constant';
import {getKeyboardKeyType} from '../../common/function';

export default function useSmoothKeyScroll(scrollSpeed = 25) {
  const scrollDirectionRef = useRef<Direction>(Direction.None);
  const scrollDistanceRef = useRef<number>(0);
  const currentFrameRef = useRef<number>();

  useEffect(() => {
    const onKeyEvent = (event: KeyboardEvent) => {
      const modifier =
        event.ctrlKey || event.altKey || event.metaKey || event.shiftKey;
      const keyType = getKeyboardKeyType(event);
      if (
        event.defaultPrevented ||
        modifier ||
        (keyType !== KeyboardKeyType.ArrowUp &&
          keyType !== KeyboardKeyType.ArrowDown)
      ) {
        return;
      }

      const newDirection =
        keyType === KeyboardKeyType.ArrowUp ? Direction.Up : Direction.Down;

      if (event.type === 'keydown') {
        // 호출하지 않으면 브라우저의 기본 스크롤 동작 때문에 끊기는 현상이 생긴다.
        event.preventDefault();
        scroll(newDirection);
      } else if (
        event.type === 'keyup' &&
        newDirection === scrollDirectionRef.current
      ) {
        stop();
      }
    };

    const scroll = (direction: Direction) => {
      scrollDirectionRef.current = direction;
      scrollDistanceRef.current = direction * scrollSpeed;

      if (!currentFrameRef.current) {
        currentFrameRef.current = requestAnimationFrame(step);
      }
    };

    const stop = () => {
      scrollDirectionRef.current = Direction.None;
      scrollDistanceRef.current = 0;
      if (currentFrameRef.current) {
        cancelAnimationFrame(currentFrameRef.current);
        currentFrameRef.current = undefined;
      }
    };

    const step = () => {
      currentFrameRef.current = requestAnimationFrame(step);
      window.scrollBy(0, scrollDistanceRef.current);
    };

    window.addEventListener('keydown', onKeyEvent);
    window.addEventListener('keyup', onKeyEvent);

    return () => {
      window.removeEventListener('keydown', onKeyEvent);
      window.removeEventListener('keyup', onKeyEvent);
      stop();
    };
  }, [scrollSpeed]);
}

enum Direction {
  None = 0,
  Up = -1,
  Down = 1,
}
